<template>
  <div>
    <b-card>
      <title-text />
      <summary-content />
      <content-text />
      <ordering-number />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Corporate_policies_categories/elements/TitleText.vue'
import SummaryContent from '@/views/Admin/Corporate_policies_categories/elements/SummaryContent.vue'
import ContentText from '@/views/Admin/Corporate_policies_categories/elements/ContentText.vue'
import OrderingNumber from '@/views/Admin/Corporate_policies_categories/elements/OrderingNumber.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleText,
    SummaryContent,
    ContentText,
    OrderingNumber,
  },
  computed: {
    itemData() {
      return this.$store.getters['corporatePoliciesCategories/dataItem']
    },
  },
}
</script>
